module.exports = __webpack_public_path__ + "static/media/code.b793276c.svg";